export interface FreeChatInputInitialValues {
  message: string | null;
  freeMessage: string | null;
  receptionDatetime: string;
  updatedAt: string;
  type: number | null;
  messageType: number | null;
}

export const freeChatInputInitialValues: FreeChatInputInitialValues = {
  message: null,
  freeMessage: null,
  receptionDatetime: '',
  updatedAt: '',
  type: null,
  messageType: null,
};
